import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setItineraryData } from '../actions/main-actions'
import { ItineraryContent } from '../components/popups/itinerary'
import { useItinerary } from '../hooks'
import { ItineraryPlaceholder } from '../components/placeholders'

export default function ItineraryPage({
  countrySlug,
  shopSlug,
  itinerarySlug,
}) {
  const dispatch = useDispatch()
  const { isLoading, itinerary, getItineraryDetails } = useItinerary({
    countrySlug,
    shopSlug,
    itinerarySlug,
  })
  useEffect(() => {
    dispatch(
      setItineraryData({
        countrySlug,
        shopSlug,
        itinerarySlug,
      })
    )
    getItineraryDetails()
  }, [])

  if(isLoading) {
    return <ItineraryPlaceholder />
  }
  return <ItineraryContent itinerary={itinerary} />
}
